import ZariSelect from './select'
import ZariMultipleSelect from './multiple'

ZariSelect.Multiple = ZariMultipleSelect

export default ZariSelect
